import * as Yup from "yup";

export const loginSchema = Yup.object({
  user_outo_no: Yup.string().trim().required("Username is required"),
  user_pass_auto: Yup.string().trim().required("Password is required"),
});
